import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatInput } from '@angular/material/input';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, finalize, switchMap, take, tap } from 'rxjs/operators';
import { ScanService } from '../../services/scan.service';
import { MatDialogRef } from '@angular/material/dialog';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-scan-input-for-order-modal',
  templateUrl: './scan-input-for-order-modal.html',
  styleUrls: ['./scan-input-for-order-modal.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ScanInputForOrderModal implements OnInit, AfterViewInit {
  @Input() modalType: 'sku' | 'order';
  @Input() placeholder: string = 'Insert barcode number';
  @Input() showContainer: boolean;
  @Input() buttonChangeColor: string = '';
  @Input() title: string = 'Scan Barcode/SKU';
  @Input() subtitle: string = 'Or you can insert barcode/SKU number';
  @ViewChild(MatInput) barcodeInputRef: MatInput;
  @ViewChild('focusInput') focusInputRef: ElementRef;
  barcodeForm = new UntypedFormGroup({
    barcode: new UntypedFormControl('', [Validators.required]),
  });
  submitting = false;

  constructor(
    private scanService: ScanService,
    public dialogRef: MatDialogRef<any>,
  ) {}
  ngAfterViewInit() {
    this.focusInputRef.nativeElement.focus();
  }

  ngOnInit(): void {
    this.barcodeForm.controls.barcode.valueChanges.pipe(untilDestroyed(this)).subscribe((barcodeValue) => {
      this.barcodeForm.patchValue(
        {
          barcode: barcodeValue?.trim(),
        },
        { emitEvent: false },
      );
    });
  }

  onSubmit(): void {
    this.submitting = true;
    switch (this.modalType) {
      case 'sku':
        this.scanService.itemScanned$
          .pipe(
            untilDestroyed(this),
            take(1),
            finalize(() => {
              this.submitting = false;
              this.barcodeForm.reset();
            }),
          )
          .subscribe();
        this.scanService.scanSkuBarcode(this.barcodeForm.value.barcode);
        break;
      case 'order':
        this.scanService
          .getOrdersByShippingId(this.barcodeForm.value.barcode)
          .pipe(
            untilDestroyed(this),
            tap((orders) => {
              if (orders.length > 1) {
                this.scanService.toggleScanSelectOrdersDialog(orders);
              }
            }),
            filter((orders) => orders.length === 1),
            switchMap((orders) => {
              return this.scanService.syncAndScanOrder(orders[0].id, orders[0].shippingId);
            }),
            finalize(() => {
              this.submitting = false;
              this.barcodeForm.reset();
            }),
          )
          .subscribe((order) => {
            this.scanService.toggleScanOrderSuccessDialog(null);
            this.scanService.toggleScanOrderDialogOpened(order);
          });

        break;
    }
  }
}
